// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    buttonText: "Get Started",
    card1ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-1.avif",
        alt: ""
    },
    card1Text: "Proactively sources, enriches, and scores new leads, 24/7.",
    card1Title: "SDR Expert",
    card2ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-2.avif",
        alt: ""
    },
    card2Text: "Generates market research and trend reports, daily.",
    card2Title: "Competitor Analyzer",
    card3ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-4.avif",
        alt: ""
    },
    card3Text: "Just ask. The assistant handles your work for you.",
    card3Title: "monday sidekick <br />",
    card4ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-3.avif",
        alt: ""
    },
    card4Text: "Flags risks and automates project processes, in real time.",
    card4Title: "Project Assistant",
    card5ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-5.avif",
        alt: ""
    },
    card5Text: "Automatically triages and resolves support tickets.",
    card5Title: "Service Agent",
    card6ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-6.avif",
        alt: ""
    },
    card6Text: "Plans sprints, assigns work, and flags blockers.",
    card6Title: "Scrum Master",
    comingSoon: "Coming soon",
    secondButtonText: "Visit our AI Trust Center",
    subTitle: "Describe the job. Your custom AI assistant is created, ready to work 24/7.",
    title: "Meet your AI assistants"
};
